import useUrl from './helpers/useUrl'

/** @param {import("@nuxtjs/axios").NuxtAxiosInstance} client */
export default (client) => {
  const root = useUrl('users')

  return {
    /** @param {Object} SendUtmDTO
      * @param {string} SendUtmDTO.utm */
    sendUtm({ utm }) {
      const url = root('utm')
      const headers = {
        ['x-analytics-utm']: utm,
      }
      return client.post(url, { utm }, { headers })
    },

    /** @param {Object} GetAuthByTempTokenDTO
      * @param {string} GetAuthByTempTokenDTO.token */
    getAuthByTempToken({ token }) {
      const url = root('restore-token')
      return client.post(url, { temp_token: token })
    },
  }
}
